import { useTranslations } from "next-intl";

interface SetupStepsProps {
  currentStep: 1 | 2 | 3 | 4;
  t: ReturnType<typeof useTranslations>;
}

export default function SetupSteps(props: SetupStepsProps) {
  let steps: { id: number, label: string }[] = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 }
  ].map(t => {
    return { ...t, label: props.t(`flow_step-${t.id}`) }
  });

  return (
    <>
      <ul className="hidden md:inline-grid steps steps-vertical text-sm md:text-base md:steps-horizontal">
        {steps.map((s, i) => {
          return (
            <li key={`step-${i}`} className={props.currentStep >= s.id ? "step step-accent" : "step"}>
              {s.label}
            </li>
          )
        })}
      </ul>
      <div className="flex flex-col md:hidden w-full items-center gap-4">
        <progress className="progress progress-accent w-[300px]" value={props.currentStep} max={4}>
        </progress>
        <div className="w-full text-center text-sm">
          {steps[props.currentStep - 1].label}
        </div>
      </div>
    </>

  )
}
